import React from 'react';
import { Typography, Box } from '@mui/material';
import { CountryOption, FlagContainer } from '../styles/StyledComponents';

const CountrySelector = ({ selectedCountry, onSelectCountry }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Select your country
      </Typography>
      
      <CountryOption 
        selected={selectedCountry === 'us'} 
        onClick={() => onSelectCountry('us')}
      >
        <FlagContainer>
          <Box 
            component="img" 
            src="https://flagcdn.com/w40/us.png" 
            alt="US flag"
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </FlagContainer>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={500}>
            United States
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Medical services in the United States
          </Typography>
        </Box>
      </CountryOption>

      <CountryOption 
        selected={selectedCountry === 'cl'} 
        onClick={() => onSelectCountry('cl')}
      >
        <FlagContainer>
          <Box 
            component="img" 
            src="https://flagcdn.com/w40/cl.png" 
            alt="Chile flag"
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </FlagContainer>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={500}>
            Chile
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Medical services in Chile
          </Typography>
        </Box>
      </CountryOption>
    </Box>
  );
};

export default CountrySelector;